console.log('Built by Granite Digital. 👉 http://granite.ie 👀');


// ScrollReveal Settings
window.sr = ScrollReveal({ reset: true, scale: 1 });
// ScrollReveal triggers
sr.reveal('.banner h1', { origin: 'bottom', duration: 1000 });
sr.reveal('.banner a', { origin: 'bottom', delay:500, duration: 1000 });
sr.reveal('.card', { origin: 'bottom', duration: 1000 });
sr.reveal('.solution__icon', { duration: 1000 });



$(document).ready(function() {

  setTimeout(function () {
    resize_Global();
  }, 800);
  // we use throttle not to spawn resize every time
  $(window).resize($.throttle(250, resize_Global));

});

// -------------------------------------------------
// global changes on resize
// -------------------------------------------------
function resize_Global() {
  equalizeHeight($('.mosaic-tile:not(.mosaic--big) h2'));
  if (window.innerWidth > 767) {
    equalizeHeight($('.cards .card-text'));
  }
  else {
    $('.cards .card-text').css('height', '');
  }
}

// -------------------------------------------------
// equalizeHeight() : levels selected elements to the same height
// -------------------------------------------------

function equalizeHeight(element) {
  var maxHeight = 0;
  element.css("height", "");
  element.each(function() {
    if ($(this).outerHeight() > maxHeight) {
      maxHeight = $(this).outerHeight();
    }
  });
  if (maxHeight > 0) {
    element.css("height", maxHeight);
  }
}

// set windows width
function resize_WindowsWidth() {
  var windowsWidth = window.innerWidth;
}

resize_WindowsWidth();

// return current page offset
function getCurrentScroll() {
  return window.pageYOffset;
}

/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b, c) {
  var $ = b.jQuery || b.Cowboy || (b.Cowboy = {}),
    a;
  $.throttle = a = function(e, f, j, i) {
    var h, d = 0;
    if (typeof f !== "boolean") {
      i = j;
      j = f;
      f = c
    }

    function g() {
      var o = this,
        m = +new Date() - d,
        n = arguments;

      function l() {
        d = +new Date();
        j.apply(o, n)
      }

      function k() {
        h = c
      }
      if (i && !h) {
        l()
      }
      h && clearTimeout(h);
      if (i === c && m > e) {
        l()
      } else {
        if (f !== true) {
          h = setTimeout(i ? k : l, i === c ? e - m : e)
        }
      }
    }
    if ($.guid) {
      g.guid = j.guid = j.guid || $.guid++
    }
    return g
  };
  $.debounce = function(d, e, f) {
    return f === c ? a(d, e, false) : a(d, f, e !== false)
  }
})(this);
